import { zoningApi, type UploadPictureDto } from '../../apis/zoning-api';
import { MissingCropPictureError } from './missing-crop-picture-error';
import {
  deletePendingCropPicture,
  ensurePendingCropPicture,
  loadPendingCropPictureFile,
} from './pending-crop-pictures';

async function resolvePicture(props: UploadPictureDto): Promise<{
  picture: File;
  pictureId?: string;
}> {
  const pictureId = await ensurePendingCropPicture(props);

  let picture = props.picture;
  if ((!picture || picture.size === 0) && pictureId) {
    picture = (await loadPendingCropPictureFile(pictureId)) ?? undefined;
    if (picture) {
      props.picture = picture;
    }
  }

  if (!picture || picture.size === 0) {
    throw new MissingCropPictureError();
  }

  return { picture, pictureId };
}

/** Persist bytes first, upload, then drop the local copy on success. */
export async function uploadCropPicturePersisted(
  props: UploadPictureDto
): Promise<unknown> {
  const { picture, pictureId } = await resolvePicture(props);

  try {
    const result = await zoningApi.uploadCropPicture({
      measureId: props.measureId,
      field: props.field,
      picture,
      pictureId,
    });
    if (pictureId) {
      await deletePendingCropPicture(pictureId);
    }
    return result;
  } catch (error) {
    // Keep pending bytes so a later resume / retry can still upload.
    throw error;
  }
}
